export class TriggeredAction {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "icon",
            "baseName": "icon",
            "type": "string",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TriggeredAction.attributeTypeMap;
    }
    constructor() {
    }
}
